export function parseSiteScopedRouteParam (value: string | undefined): { value: string, siteId: string; }
{
    const routeValue = value || '';
    const siteIdSeparatorIndex = routeValue.lastIndexOf('@');

    if (siteIdSeparatorIndex === -1)
        return { value: routeValue, siteId: '' };

    return {
        value: routeValue.substring(0, siteIdSeparatorIndex),
        siteId: routeValue.substring(siteIdSeparatorIndex + 1)
    };
}